import type { SupportedAlpha2CountryCode } from '@/lib/utils/localization/getSupportedAlpha2CountryCodes'
import type { MarketExceptionType } from './MarketExceptionTypes'
import { PR } from './Markets/Americas/PR'
import { DO } from './Markets/Americas/DO'
import { US } from './Markets/Americas/US'
import { CA } from './Markets/Americas/CA'
import { NL } from './Markets/Europe/NL'
import { CZ } from './Markets/Europe/CZ'
import { AT } from './Markets/Europe/AT'
import { BE } from './Markets/Europe/BE'
import { DE } from './Markets/Europe/DE'
import { DK } from './Markets/Europe/DK'
import { FR } from './Markets/Europe/FR'
import { HU } from './Markets/Europe/HU'
import { IT } from './Markets/Europe/IT'
import { LU } from './Markets/Europe/LU'
import { NO } from './Markets/Europe/NO'
import { PL } from './Markets/Europe/PL'
import { IE } from './Markets/Europe/IE'
import { ES } from './Markets/Europe/ES'
import { SE } from './Markets/Europe/SE'

const marketExceptions: {
  [key in SupportedAlpha2CountryCode]: MarketExceptionType
} = {
  AT,
  BE,
  DE,
  DK,
  FR,
  HU,
  IT,
  LU,
  NO,
  PL,
  IE,
  ES,
  SE,
  CA,
  PR,
  DO,
  US,
  NL,
  CZ,
}

export default marketExceptions
